<template>
	<div>

		<el-row>
			<el-col :span="12"><h1 class="prescriptions-title">Prescriptions</h1></el-col>
			<el-col :span="12" style="text-align: right;"><el-link type="primary" v-on:click="$emit('hide-prescriptions')">Retour bilan&nbsp;<i class="fas fa-long-arrow-alt-right"></i></el-link></el-col>
		</el-row>

		<!-- FORMULAIRE -->
		<el-row v-if="editMode" :gutter="20" v-loading="loadingEditMode">
			<el-col :lg="{span: 12, offset: 6}" :md="{span: 16, offset: 4}" :sm="{span: 20, offset: 2}" :xs="24">
				<el-form ref="itemForm" :model="item" label-width="150px">
									
					<el-form-item label="Médicament / Geste" prop="medGesId">
						<el-select v-model="medGesId" placeholder="Médicament / Geste" class="select">
							<el-option-group label="Médicaments">
								<el-option v-for="medication in medications" :key="'m' + medication.id" :label="medication.label" :value="'m' + medication.id"></el-option>
							</el-option-group>
							<el-option-group label="Gestes">
								<el-option v-for="gesture in gestures" :key="'g' + gesture.id" :label="gesture.label" :value="'g' + gesture.id"></el-option>
							</el-option-group>
						</el-select>
					</el-form-item>

					<el-form-item label="Mode d'administration" prop="shortName">
						<el-select v-model="giveModeId" placeholder="Mode d'administration" class="select" :disabled="!item.medication">
							<el-option v-for="giveMode in giveModes" :key="giveMode.id" :label="giveMode.label" :value="giveMode.id"></el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="Dosage" prop="dosage">
						<el-input v-model="item.dosage" placeholder="Dosage" maxlength="100"></el-input>
					</el-form-item>

					<el-form-item label="Observations" prop="observations">
						<el-input v-model="item.observations" placeholder="Observations" maxlength="500" type="textarea" autosize></el-input>
					</el-form-item>

					<div style="text-align: center;">
						<el-button icon="fas fa-times" @click="exitEditMode"> Annuler</el-button>
						<el-button icon="fas fa-save" type="primary" @click="submit" :disabled="!medGesId"> Enregistrer</el-button>
					</div>
				</el-form>
			</el-col>
		</el-row>

		<!-- LISTE -->
		<div v-else class="items-card">
			<el-row :gutter="20">
				<el-col :xs="9" :sm="12" :md="11" :lg="13" :xl="14">
					<el-button 
						:disabled="!currentUser.doctor"
						size="small" 
						type="success" 
						icon="fas fa-fw fa-plus" 
						title="Ajouter une prescription" 
						v-on:click="enterEditMode">
						<span class="hidden-xs-only"> Ajouter</span>
					</el-button>
				</el-col>
				<el-col :xs="15" :sm="12" :md="13" :lg="11" :xl="10">
					<el-input size="small"
						class="search-input"
						placeholder="Rechercher une prescription"
						prefix-icon="fas fa-search"
						v-model="searchQuery"
						v-on:input="setSearchQueries"
						v-on:clear="setSearchQueries"
						clearable>
					</el-input>
				</el-col>
			</el-row>

			<el-table
				ref="itemTable"
				:data="filteredItems" 
				:default-sort="{prop: 'datPrescription', order: 'ascending'}"
				style="width: 100%"
				height="calc(100vh - 360px)"
				border
				stripe
				class="items-table">

				<!-- Heure de la prescription -->
				<el-table-column width="90" prop="datPrescription" align="center"  sortable :sort-method="sortByPrescriptionDate">
					<template slot="header">
						Heure<br>prescription
					</template>
					<template slot-scope="scope">
						{{getFormatedHour(scope.row.datPrescription)}}<br>
						{{getFormatedDate(scope.row.datPrescription)}}
					</template>
				</el-table-column>

				<!-- Medicament / Geste -->
				<el-table-column sortable :sort-method="sortByMedicationGesture" header-align="center">
					<template slot="header">
						Médic<span class="hidden-sm-and-down">ament</span><br>Geste<br>
					</template>
					<template slot-scope="scope">
						<span v-if="scope.row.medication">{{scope.row.medication.label}}</span>
						<span v-if="scope.row.gesture">{{scope.row.gesture.label}}</span>
					</template>
				</el-table-column>

				<!-- Mode d'administration -->
				<el-table-column prop="giveMode.label" sortable :sort-method="sortByGiveMode" header-align="center">
					<template slot="header">
						Mode<br><span class="hidden-lg-and-down">d'</span>admin<span class="hidden-md-and-down">istration</span><br>
					</template>
				</el-table-column>
				
				<!-- Dosage -->
				<el-table-column prop="dosage" sortable header-align="center">
					<template slot="header">
						Dosage<br><br>
					</template>
				</el-table-column>
				
				<!-- Observations -->
				<el-table-column prop="observations" sortable header-align="center">
					<template slot="header">
						Observ<span class="hidden-md-and-down">ations</span><br><br>
					</template>
				</el-table-column>

				<!-- Prescripteur -->
				<el-table-column sortable :sort-method="sortByUser" header-align="center">
					<template slot="header">
						RPPS du<br>prescript<span class="hidden-sm-and-down">eur</span><br>
					</template>
					<template slot-scope="scope" v-if="scope.row.user">
						{{ scope.row.user.rpps }}
					</template>
				</el-table-column>
				
				<!-- Effectueur SP -->
				<el-table-column prop="nomEffectueur" sortable header-align="center">
					<template slot="header">
						Effectueur<br>SP<br>
					</template>
				</el-table-column>

				<!-- Réalisé -->
				<el-table-column
					width="75"
					align="center"
					:filters="[{ text: 'Oui', value: true }, { text: 'Non', value: false }, { text: 'Inconnu', value: null }]"
					:filter-method="filterRealise"
					filter-placement="bottom-end">
					<template slot="header">
						Acte<br>réalisé<br>
					</template>
					<template slot-scope="scope">
						<i v-if="scope.row.realise === true" class="fas fa-lg fa-check vert-color"></i>
						<i v-else-if="scope.row.realise === false" class="fas fa-lg fa-times rouge-color"></i>
						<i v-else class="fas fa-lg fa-question jaune-color"></i>
					</template>
				</el-table-column>

				<!-- Heure de réalisation -->
				<el-table-column width="85" align="center" sortable :sort-method="sortByRealisationDate">
					<template slot="header">
						Heure<br>réalisation
					</template>
					<template slot-scope="scope" v-if="scope.row.datRealisation">
						{{getFormatedHour(scope.row.datRealisation)}}<br>
						{{getFormatedDate(scope.row.datRealisation)}}
					</template>
				</el-table-column>

				<!-- Observations SP -->
				<el-table-column prop="observationsSP" sortable header-align="center">
					<template slot="header">
						Observ<span class="hidden-md-and-down">ations</span><br>SP<br>
					</template>
				</el-table-column>
				
			</el-table>
		</div>
	</div>
</template>

<script>
import PrescriptionService from '@/services/prescription.service'
import MedicationService from '@/services/medication.service'
import GestureService from '@/services/gesture.service'
import UserService from '@/services/user.service'
import StringUtils from '@/utils/string.utils'
import moment from 'moment';

export default {
	name: 'prescriptions',
	props: {
		items: { type: Array, default: [] },
		victimId: { type: Number }
    },
	data: function () {
		return {
			searchQuery: '',
			searchQueries: [],
			item: {},
			editMode: false,
			loadingEditMode: false,
			medications: [],
			gestures: [],
			giveModes: [],
			medGesId: null,
			giveModeId: null,
		}
	},
	computed: {
		filteredItems: function () {
			if (!this.searchQueries || this.searchQueries.length === 0) {
				return this.items
			}

			return this.items.filter(item => {
				return StringUtils.matchAll(item.searchText, this.searchQueries)
			})
		},
		currentUser: function() {
			return UserService.getCurrentUser()
		}
	},
	methods: {
		setSearchQueries() {
			if (this.timeout) clearTimeout(this.timeout); 
			this.timeout = setTimeout(() => {

				if (this.searchQuery) {
					this.searchQueries = this.searchQuery.split(' ')
				} else {
					this.searchQueries = []
				}

			}, 350);
		},
		getFormatedHour(date) {
			return moment(date).format('LT')
		},
		getFormatedDate(date) {
			return moment(date).format('DD/MM')
		},
		sortByPrescriptionDate(a, b) {
			return moment(a.datPrescription).diff(b.datPrescription, 'minutes')
		},
		sortByMedicationGesture(a, b) {
			const _a = (a.medication ? a.medication.label : '') + (a.gesture ? a.gesture.label : '')
			const _b = (b.medication ? b.medication.label : '') + (b.gesture ? b.gesture.label : '')
			return StringUtils.compareIgnoreCase(_a, _b)
		},
		sortByGiveMode(a, b) {
			return StringUtils.compareIgnoreCase((a.giveMode ? a.giveMode.label : ''), (b.giveMode ? b.giveMode.label : ''))
		},
		sortByUser(a, b) {
			const _a = (a.user ? a.user.lastname : '') + (a.user ? a.user.firstname : '')
			const _b = (b.user ? b.user.lastname : '') + (b.user ? b.user.firstname : '')
			return StringUtils.compareIgnoreCase(_a, _b)
		},
		filterRealise(value, row) {
			return row.realise === value
		},
		sortByRealisationDate(a, b) {
			return moment(a.datRealisation).diff(b.datRealisation, 'minutes')
		},
		enterEditMode() {
			
			this.editMode = true
			this.loadingEditMode = true
			this.item = {}
			this.medGesId = null
			this.giveModeId = null

			// Récupération des médicaments
			MedicationService.getMedicationsForPrescription().then((medications) => {

				// Pour chaque ligne,
				// Tri la liste des modes
				medications.forEach(item => {
					if (item.giveModes && item.giveModes.length) {
						item.giveModes = item.giveModes.sort((a, b) => StringUtils.compareIgnoreCase(a.label, b.label))
					}
				});

				this.medications = medications

				// Récupération des gestes
				GestureService.getGesturesForPrescription().then((gestures) => {

					this.gestures = gestures
					this.loadingEditMode = false

				})
			})
		},
		exitEditMode() {
			this.item = {}
			this.medGesId = null
			this.giveModeId = null
			this.editMode = false
		},
		submit() {
			// Affiche le loader
			this.loading = true

			this.item.victRef = this.victimId;

			// Enregistrement de l'entité
			PrescriptionService.savePrescription(this.item).then((item) => {

				// Retour liste
				this.editMode = false

				// Ajout dans liste
				this.items.push(item)
			})
		}
	},

	watch: {
		items: {
			handler () {
				// Pour la recherche des prescriptions, pour chaque ligne,
				// Construit une string utilisée pour la recherche textuelle
				this.items.forEach(item => {
					item.searchText = this.getFormatedHour(item.datPrescription)
					item.searchText += ' ' + this.getFormatedDate(item.datPrescription)
					item.searchText += item.medication ? ' ' + item.medication.label : ''
					item.searchText += item.gesture ? ' ' + item.gesture.label : ''
					item.searchText += item.giveMode ? ' ' + item.giveMode.label : ''
					item.searchText += item.dosage ? ' ' + item.dosage : ''
					item.searchText += item.observations ? ' ' + item.observations : ''
					item.searchText += item.user ? ' ' + item.user.lastname + ' ' + item.user.firstname + ' ' + item.user.rpps : ''
					item.searchText += item.nomEffectueur ? ' ' + item.nomEffectueur : ''
					item.searchText += item.datRealisation? ' ' + this.getFormatedHour(item.datRealisation) + ' ' + this.getFormatedDate(item.datRealisation) : ''
					item.searchText += item.observationsSP ? ' ' + item.observationsSP : ''
				});
			},
			immediate: true
		},

		medGesId: function(id) {

			// Médicament
			if (id && id.charAt(0) === 'm') {
				const medicationId = parseInt(id.slice(1))
				this.item.medication = { id: medicationId }
				this.item.gesture = null

				const medication = this.medications.find((med) => med.id === medicationId)

				if (medication && medication.giveModes && medication.giveModes.length) {
					this.giveModes = medication.giveModes
					this.giveModeId = medication.giveModes[0].id
				}
			}

			// Geste
			if (id && id.charAt(0) === 'g') {
				const gestureId = parseInt(id.slice(1))
				this.item.gesture = { id: gestureId }
				this.item.medication = null
				this.giveModeId = null
				this.giveModes = []
			}
		},

		giveModeId: function(id) {
			this.item.giveMode = { id: id }
		}
	}
}
</script>

<style scoped>

.items-table {
	margin-top: 15px;
}

.select {
	width: 100%;
}

@media only screen and (max-width:767px) {

	.items-table {
		height: calc(100vh - 305px) !important;
	}
}

</style>